/* eslint-disable max-classes-per-file */
import axios from 'axios';
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';

import './style.css';

const SYNC_STATUS = {
  LOADING: 'LOADING',
  UNAUTHORIZED: 'UNAUTHORIZED',
  AUTHORIZING: 'AUTHORIZING',
  VERIFYING: 'VERIFYING',
  CONNECTED: 'CONNECTED',
  ERROR: 'ERROR',
  REVOKING: 'REVOKING'
};

class CalendarLoginButton extends Component {
  render() {
    const {
      status, onClick, onRevoke, serviceName
    } = this.props;
    const disabled = status !== SYNC_STATUS.UNAUTHORIZED && status !== SYNC_STATUS.ERROR;
    return (
      <div>
        <button
          onClick={onClick}
          type="submit"
          disabled={disabled}
          className="btn btn-primary btn-blue btn-cursor"
        >
          {status === SYNC_STATUS.CONNECTED && <i className="fa fa-check fa-large pull-left" />}
          {status === SYNC_STATUS.ERROR && <i className="fa fa-warning fa-large pull-left" />}

          {status === SYNC_STATUS.LOADING && 'Loading...'}
          {status === SYNC_STATUS.AUTHORIZING && 'Authorizing...'}
          {status === SYNC_STATUS.REVOKING && 'Revoking...'}

          {status === SYNC_STATUS.VERIFYING && 'Verifying...'}
          {(status === SYNC_STATUS.UNAUTHORIZED || status === SYNC_STATUS.ERROR) &&
            `Sync ${serviceName}`}
          {status === SYNC_STATUS.CONNECTED && `${serviceName}`}
        </button>
        {(status === SYNC_STATUS.CONNECTED || status === SYNC_STATUS.ERROR) && (
          <button type="button" onClick={onRevoke} className="ml-2 btn btn-primary btn-warning btn-cursor">
            {status === SYNC_STATUS.REVOKING ? 'Revoking' : 'Revoke'}
          </button>
        )}
      </div>
    );
  }
}

class TeacherCalendarSync extends Component {
  constructor(props) {
    super(props);
    if (this.props.location.query.code) {
      // Because the redirect url cannot take a query param, we put
      // in path so we know if we're being redirected back from a
      // google or a microsoft auth flow
      const parts = this.props.location.pathname.split('/');
      const provider = parts[parts.length - 1];
      if (provider === 'microsoft') {
        this.state = {
          googleSyncStatus: SYNC_STATUS.LOADING,
          microsoftSyncStatus: SYNC_STATUS.VERIFYING
        };
        this.verifyMicrosoft(this.props.location.query.code);
      } else if (provider === 'google') {
        this.state = {
          googleSyncStatus: SYNC_STATUS.VERIFYING,
          microsoftSyncStatus: SYNC_STATUS.LOADING
        };
        this.verifyGoogle(this.props.location.query.code);
      }
    } else {
      this.state = {
        googleSyncStatus: SYNC_STATUS.LOADING,
        microsoftSyncStatus: SYNC_STATUS.LOADING
      };
    }
    this.loadAuthorizations();
  }

  onRevokeGoogle = async () => {
    this.setState({ googleSyncStatus: SYNC_STATUS.REVOKING });
    await axios
      .delete(`${process.env.REACT_APP_BACKEND_URL}/teacher/authorizations/google`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.props.user.token}`
        }
      })
      .then(() => {
        this.setState({ googleSyncStatus: SYNC_STATUS.UNAUTHORIZED });
      })
      .catch(error => {
        this.setState({ googleSyncStatus: SYNC_STATUS.ERROR });
        console.log('catch', error);
      });
  }

  onRevokeMicrosoft = async () => {
    this.setState({ microsoftSyncStatus: SYNC_STATUS.REVOKING });
    await axios
      .delete(`${process.env.REACT_APP_BACKEND_URL}/teacher/authorizations/microsoft`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.props.user.token}`
        }
      })
      .then(() => {
        this.setState({ microsoftSyncStatus: SYNC_STATUS.UNAUTHORIZED });
      })
      .catch(error => {
        this.setState({ microsoftSyncStatus: SYNC_STATUS.ERROR });
        console.log('catch', error);
      });
  }

  // @todo - async/await doesn't work this way, should have try/catch and response bount to await axios
  loadAuthorizations = async () => {
    await axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/teacher/authorizations`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.props.user.token}`
        }
      })
      .then(response => {
        const { data } = response.data;
        if (this.state.googleSyncStatus === SYNC_STATUS.LOADING) {
          if (data.includes('google')) {
            this.setState({ googleSyncStatus: SYNC_STATUS.CONNECTED });
          } else {
            this.setState({ googleSyncStatus: SYNC_STATUS.UNAUTHORIZED });
          }
        }

        if (this.state.microsoftSyncStatus === SYNC_STATUS.LOADING) {
          if (data.includes('microsoft')) {
            this.setState({ microsoftSyncStatus: SYNC_STATUS.CONNECTED });
          } else {
            this.setState({ microsoftSyncStatus: SYNC_STATUS.UNAUTHORIZED });
          }
        }
      })
      .catch(error => {
        this.setState({ googleSyncStatus: SYNC_STATUS.ERROR });
        console.log('catch', error);
      });
  }

  verifyGoogle = async (authCode) => {
    const data = {
      authCode
    };
    await axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/teacher/authorizations/google/auth-code`, data, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.props.user.token}`
        }
      })
      .then(() => {
        this.setState({ googleSyncStatus: SYNC_STATUS.CONNECTED });
        browserHistory.push('/teacher/settings/calendar-sync');
      })
      .catch(error => {
        this.setState({ googleSyncStatus: SYNC_STATUS.ERROR });
        console.log('catch', error);
      });
  }

  verifyMicrosoft = async (authCode) => {
    const data = {
      authCode
    };
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/teacher/authorizations/microsoft/auth-code`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      )
      .then(() => {
        this.setState({ microsoftSyncStatus: SYNC_STATUS.CONNECTED });
        browserHistory.push('/teacher/settings/calendar-sync');
      })
      .catch(error => {
        this.setState({ microsoftSyncStatus: SYNC_STATUS.ERROR });
        console.log('catch', error);
      });
  }

  authorizeGoogle = async () => {
    this.setState({ googleSyncStatus: SYNC_STATUS.AUTHORIZING });
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/teacher/authorizations/google`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      )
      .then(response => {
        window.location.href = response.data.redirectUrl;
      })
      .catch(error => {
        this.setState({ googleSyncStatus: SYNC_STATUS.ERROR });
        console.log('catch', error);
      });
  }

  authorizeMicrosoft = async () => {
    this.setState({ microsoftSyncStatus: SYNC_STATUS.AUTHORIZING });
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/teacher/authorizations/microsoft`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      )
      .then(response => {
        window.location.href = response.data.redirectUrl;
      })
      .catch(error => {
        this.setState({ microsoftSyncStatus: SYNC_STATUS.ERROR });
        console.log('catch', error);
      });
  }

  render() {
    const {
      error
    } = this.props;

    return (
      <div className="teacher-settings-profile__section teacher-calendar-sync mb-4 p-4 p-md-4 p-lg-5">
        <h4 className="mb-4">Sync Your Personal Calendars</h4>
        <div className="notes">
          <strong>Very Important Notes:</strong>
          <ul>
            <li>
              {
                'The Rype App is currently undergoing review with Google. If you see an unverified ' +
                'app screen when authorizing, please click "advanced" and ignore the warning.'
              }
            </li>
            <li>
              Rype will add lessons to your Google and Outlook calendars as they are booked
            </li>
            <li>
                Rype currently pulls events ONLY from Google Calendar to automatically adjust your availability.
            </li>
            <li>
              {
                'Due to timezone ambiguity, Rype ignores "all day" events. If you wish to block out full ' +
                'days, block those times in the Rype dashboard or create a calendar event that has a specific ' +
                'start and end time.'
              }
            </li>
          </ul>
        </div>
        <div style={{ marginTop: 32 }}>
          <CalendarLoginButton
            status={this.state.googleSyncStatus}
            onClick={this.authorizeGoogle}
            onRevoke={this.onRevokeGoogle}
            serviceName="Google Calendar"
          />
        </div>
        <div style={{ marginTop: 24 }}>
          <CalendarLoginButton
            status={this.state.microsoftSyncStatus}
            onClick={this.authorizeMicrosoft}
            onRevoke={this.onRevokeMicrosoft}
            serviceName="Outlook Calendar"
          />
        </div>
        {// if an error exists, render an Alert
          error && <p className="text-danger my-2">{error}</p>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { user: state.user };
}

export default connect(
  mapStateToProps,
  {}
)(TeacherCalendarSync);



// WEBPACK FOOTER //
// ./src/pages/teacher/Settings/CalendarSync/index.js